import React, { ReactElement, useEffect, useState } from 'react';
import { Button } from 'antd';
import Papa from 'papaparse';

import {
  preparePackagesForCsv,
  prepareTravelPackagesHistoryForCsv,
} from 'leash/utilities/packages/packages.utilities';
import { ExportCsvDataType, TravelPackagesHistoryTableData } from 'leash/types';
import { TravelPlan } from 'types';

interface Props {
  data: TravelPackagesHistoryTableData[] | TravelPlan[];
  dataType: ExportCsvDataType;
}

function ExportCsvData(props: Props): ReactElement {
  const { data, dataType } = props;
  const [csv, setCsv] = useState<string>('');

  const handleConvertCsvToObjectUrl = () => {
    const blob = new Blob([csv], { type: 'text/csv' });
    return URL.createObjectURL(blob);
  };

  useEffect(() => {
    if (data) {
      switch (dataType) {
        case 'travelPackages': {
          const preparedDataForCsv = preparePackagesForCsv(data as TravelPlan[]);
          const convertToCsv: string = Papa.unparse(preparedDataForCsv);
          setCsv(convertToCsv);
          break;
        }
        case 'travelPackagesHistory': {
          const prepareDataForCsv = prepareTravelPackagesHistoryForCsv(
            data as TravelPackagesHistoryTableData[],
          );
          const convertToCsv: string = Papa.unparse(prepareDataForCsv);
          setCsv(convertToCsv);
          break;
        }
      }
    }
  }, [data]);

  return (
    <Button
      type="link"
      href={handleConvertCsvToObjectUrl()}
      download={`${dataType}.csv`}
      aria-label="Export CSV File"
    >
      Export CSV File
    </Button>
  );
}

export default ExportCsvData;
